/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.js to modify the generation of this file.
module.exports = {
  "sitecoreApiKey": "{D5AD381C-4365-4F49-A739-382ABA58E854}",
  "sitecoreApiHost": "https://qa-dayross.azurewebsites.net/",
  "jssAppName": "internet",
  "defaultLanguage": "en",
  "graphQLEndpointPath": "/api/internet",
  "graphQLEndpoint": "https://qa-dayross.azurewebsites.net//api/internet?sc_apikey={D5AD381C-4365-4F49-A739-382ABA58E854}"
};